import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoPenalidade } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoPenalidadeService extends BaseResourceService<FavorecidoPenalidade> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-penalidades`, injector);
  }

}
